module.exports = __webpack_public_path__ + "img/131.1d2e8788.jpg";